import React, { useEffect, useRef } from 'react';
import GatewayService from '../../../services/gateway-service';
import { SYNC_CAMERA_ROTATION } from '../../../common/constants/gateway-events';

const CameraDirection = () => {
  const elmRef = useRef<SVGSVGElement>(null);

  useEffect(() => {
    if (!elmRef.current) return;

    const handleCameraRotationEvt = (data: any) => {
      if (elmRef.current) elmRef.current.style.transform = 'rotate(' + -data.value.y + 'rad)';
    };

    GatewayService.on(SYNC_CAMERA_ROTATION, handleCameraRotationEvt);

    return () => {
      GatewayService.off(SYNC_CAMERA_ROTATION, handleCameraRotationEvt);
    };
  }, []);

  return (
    <div className="player-addons">
      <div className="player-addon addon-direction">
        <div className="direction-cont">
          <svg width="30px" height="30px" viewBox="0 0 60 60" ref={elmRef}>
            <g fill="#ffffff" stroke="none" fillRule="evenodd">
              <path d="M30,60 C46.5685425,60 60,46.5685425 60,30 C60,13.4314575 46.5685425,0 30,0 C13.4314575,0 0,13.4314575 0,30 C0,46.5685425 13.4314575,60 30,60 Z M30,58 C45.463973,58 58,45.463973 58,30 C58,14.536027 45.463973,2 30,2 C14.536027,2 2,14.536027 2,30 C2,45.463973 14.536027,58 30,58 Z"></path>
              <path d="M42.7174074,12.0460131 C39.1265957,9.49790578 34.7382252,8 30,8 C25.2617748,8 20.8734043,9.49790578 17.2825926,12.0460131 L25.3754882,23.4712775 C26.6812379,22.544693 28.277009,22 30,22 C31.722991,22 33.3187621,22.544693 34.6245118,23.4712775 L42.7174074,12.0460131 Z"></path>
              <path d="M26,30 a4,4 0 1,1 8,0 a4,4 0 1,1 -8,0"></path>
            </g>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default CameraDirection;
